import React from 'react';

import * as S from './info-icon.styles';
const ICON_SIZE = 18;

type InfoIconProps = {
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
  children?: React.ReactNode;
  'data-testid'?: string;
};

export const InfoIcon: React.FC<InfoIconProps> = ({ Icon, children, 'data-testid': dataTestId }) => (
  <S.StyledInfoIcon data-testid={dataTestId}>
    <Icon width={ICON_SIZE} height={ICON_SIZE} />
    {children}
  </S.StyledInfoIcon>
);
